import React, { useEffect, useState } from "react";
import styles from "../../../src/assets/scss/Billing/InvoiceDesign.module.scss";
import html2canvas from "html2canvas";
import { useGetUserByIdQuery } from "../../slices/admin/admin";
import { BaseURL } from "../../lib/api";
import { getUserInfo } from "../../utils/user.util";

const formatCurrency = (v) => (v == null ? "₹0.00" : "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const formatDate = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
const formatTime = (iso) => new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true });

const InvoiceDesignAddBilling = ({ data = {}, mode = "thermal" }) => {

  // console.log(data,"data44444444");

    const localUser = getUserInfo();
    const userId = localUser?._id;

    const { data: userData } = useGetUserByIdQuery(userId, { skip: !userId });

    const [printerLogo, setPrinterLogo] = useState(null);
    const [printerOption, setPrinterOption] = useState(80);

    useEffect(() => {
        const user = userData?.result?.[0];
        // if (user?.isPrintLogo && user.store?.logo) setPrinterLogo(`${BaseURL}/${user.store.logo}`);
        if (user?.isPrintLogo && user.store?.logo) {
            const logoPath = resolveImageUrl(user.store.logo);
            setPrinterLogo(logoPath);
        }

        if (user?.printerOption) setPrinterOption(user.printerOption);
    }, [userData]);

    const items = data.items || [];
    const subtotal = items.reduce((s, it) => s + Number(it.price || 0) * Number(it.productQuantity || 0), 0);
    const handleCharge = Number(data.handleCharge || 0);
    const logisticCharge = Number(data.logisticCharge || 0);
    const total = subtotal + handleCharge + logisticCharge;

    // ✅ Handle both absolute & relative image URLs cleanly
    const resolveImageUrl = (path) => {
        if (!path) return null;
        return path.startsWith("http")
            ? path
            : `${BaseURL.replace(/\/$/, "")}/${path.replace(/^\/+/, "")}`;
    };


    const handlePrint = async () => {
        const invoiceElement = document.getElementById("print-area");
        if (!invoiceElement) return;

        invoiceElement.querySelectorAll(".addBtn, .noPrint").forEach((btn) => (btn.style.display = "none"));

        await Promise.all(
            Array.from(invoiceElement.querySelectorAll("img")).map((img) => img.complete ? Promise.resolve() : new Promise((res) => { img.onload = res; img.onerror = res; }))
        );

        const canvas = await html2canvas(invoiceElement, { scale: 2, useCORS: true, allowTaint: true, backgroundColor: "#fff" });
        const imgData = canvas.toDataURL("image/png");

        invoiceElement.querySelectorAll(".addBtn, .noPrint").forEach((btn) => (btn.style.display = ""));

        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Invoice</title>
              <style>body, html { margin:0; padding:0; background:#fff; } img { max-width:100%; display:block; margin:auto; }</style>
            </head>
            <body>
              <img src="${imgData}" />
              <script>window.onload = function() { window.print(); window.onafterprint = function(){ window.close(); } }</script>
            </body>
          </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.invoiceBox} id="print-area">
                <div className={styles.header}>
                    {/* {printerLogo ? <img src={printerLogo} alt="Logo" className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`} /> : null} */}
                    {printerLogo && (
                        <img
                            src={printerLogo}
                            alt="Logo"
                            onError={(e) => (e.target.style.display = "none")}
                            className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`}
                        />
                    )}

                    {userData?.result?.[0]?.store && (
                        <div className={styles.storeInfo}>
                            <div className={styles.storeName}>{userData.result[0].store.storeName}</div>

                            {userData.result[0].store.gst &&
                                <div className={styles.storeAddress}>
                                    <div className={styles.storeGST}>GST: {userData.result[0].store.gst}
                                    </div>
                                </div>}

                            <div className={styles.storeAddress}>
                                {[userData.result[0].store.address, userData.result[0].store.address1, userData.result[0].store.city].filter(Boolean).join(", ")}
                            </div>
                            <div className={styles.storeAddress}>
                                {[userData.result[0].store.state, userData.result[0].store.pincode].filter(Boolean).join(" - ")}
                            </div>
                        </div>
                    )}
                    <h2 className={styles.headingtitle}>Receivable Bill</h2>
                </div>

                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        <div>
                            <span className={styles.label}>Name</span>
                            <span className={styles.labelsname}> : {data.customer?.firstName || "Guest"}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Phone</span> <span className={`${styles.labels} notranslate`}>: {data.customer?.phone || "-"}</span>
                        </div>
                    </div>
                </div>

                <hr className={styles.dotted} />

                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        <div><span className={styles.label}>Bill No</span> <span className={`${styles.labels} notranslate`}>: {data.receiptNo || "-"}</span></div>
                        <div><span className={styles.label}>Date</span> <span className={`${styles.labels} notranslate`}>: {formatDate(data.createdAt)}</span></div>
                        <div><span className={styles.label}>Time</span> <span className={`${styles.labels} notranslate`}>: {formatTime(data.createdAt)}</span></div>
                    </div>
                </div>

                <hr className={styles.dotted} />

                <table className={styles.invoiceTable}>
                    <thead>
                        <tr>
                            <th className={styles.itemHeader}>Item Name</th>
                            <th className={styles.qtyHeader}>Quantity</th>
                            <th className={styles.priceHeader}>Price</th>
                            <th className={styles.totalHeader}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it, idx) => {
                            const amt = Number(it.price || 0) * Number(it.productQuantity || 0);
                            return (
                                <tr key={idx}>
                                    <td className={styles.itemCell}>{it.productName ? it.productName.charAt(0).toUpperCase() + it.productName.slice(1) : "-"}</td>
                                    <td className={`${styles.qtyCell} notranslate`}>{it.productQuantity || 0} {it.productQuality ? `(${it.productQuality})` : ""}</td>
                                    <td className={`${styles.priceCell} notranslate`}>{formatCurrency(it.price)}</td>
                                    <td className={`${styles.totalCell} notranslate`}>{formatCurrency(amt)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <hr className={styles.dotted} />

                <div className={styles.summary}>
                    <div className={styles.summaryRow}>
                        <div className={styles.qtys}>Items/Qty :</div>
                        <div className={`${styles.qtys} notranslate`}>{items.length} / {items.reduce((s, it) => s + Number(it.productQuantity || 0), 0)}</div>
                    </div>

                    <div className={styles.totals}>
                        <div className={styles.totalRow}><div className={styles.fixwidths}><p className={styles.fixwidth}>Payment Type</p> : </div><div className={styles.payable}>{data.paymentMethod || "-"}</div></div>
                        <div className={styles.totalRow}><div className={styles.fixwidths}><p className={styles.fixwidth}>Subtotal</p> : </div><div className={`${styles.totalAmount} notranslate`}>{formatCurrency(subtotal)}</div></div>
                        <div className={styles.totalRow}><div className={styles.fixwidths}><p className={styles.fixwidth}>Handling Charge</p> : </div><div className={`${styles.totalAmount} notranslate`}>{formatCurrency(handleCharge)}</div></div>
                        <div className={styles.totalRow}><div className={styles.fixwidths}><p className={styles.fixwidth}>Logistic Charge</p> : </div><div className={`${styles.totalAmount} notranslate`}>{formatCurrency(logisticCharge)}</div></div>
                        <hr className={styles.dotted} />
                        <div className={styles.totalRow}><div className={styles.fixwidths}><p className={styles.fixwidth}>Total Amount</p> : </div><div className={`${styles.grandAmount} notranslate`}>{formatCurrency(total)}</div></div>
                    </div>

                    <div className={styles.footer}>
                        {mode === "thermal" && <button className={`${styles.addBtn} noPrint`} onClick={handlePrint}>Print</button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDesignAddBilling;
